import { DollarOutlined } from "@ant-design/icons";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage";
import { Route as FinanceBonusPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/bonus";
import { Route as FinanceCostsPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/cost";
import { Route as FinancePenaltyPage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/penalty";
import { Route as FinanceRevenuePage } from "routes/_authenticated/$tenantSlug/_layout/finance/_layout/revenue";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/finance/")({
    component: FinancePage,
    staticData: {
        /*permissions: [
            PermissionEnum.FinanceCostView,
            PermissionEnum.FinanceBonusView,
            PermissionEnum.FinancePenaltyView,
            PermissionEnum.FinanceRevenueView,
        ],*/
        permissions: [],
        showInSideMenu: true,
        label: "pages.finance.title",
        icon: <DollarOutlined />,
        sort: 7,
        redirects: [FinanceBonusPage, FinanceCostsPage, FinancePenaltyPage, FinanceRevenuePage],
        defaultRedirect: FinanceCostsPage,
    },
});
function FinancePage() {
    return <RedirectPage />;
}
